<script>
    export let currentTime = 0;
    export let duration = 0;

    function formatTime(time) {
        // Reject undefined, null, NaN, and Infinity
        if (!time || !Number.isFinite(time)) {
            return "00:00:00";
        }

        try {
            return new Date(time * 1000).toISOString().substring(11, 19);
        } catch (e) {
            return "00:00:00";
        }
    }
</script>

{formatTime(currentTime)} -- {formatTime(duration)}
